export default {
  // START:: GET APP THEME
  getAppTheme(state) {
    return state.modo_dashboard_theme;
  },
  // END:: GET APP THEME GETTER
};
